import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Table,
  DropdownItem,
  DropdownMenu,
  UncontrolledCollapse,
  DropdownToggle,
  Dropdown,
  FormGroup,
  Input,
  Tooltip,
} from "reactstrap";
import ProfileAvatar from "../../../constants/Images/defaultAvatar-1.png";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import { authHeader } from "../../../functions/CoreFunctions";
import { debounce } from "underscore";
import API from "../../../redux/actions/API";
import {
  AGENCY_CUSTOMER_REPORT,
  STATE_LIST,
} from "../../../constants/ApiPaths";
import { getAgencyId } from "../../common/CommonFunctions";
import Pagination from "../../common/Pagination";
import moment from "moment";
import generatePDF from "./CustomerReportGenerator";
import { CSVLink } from "react-csv";
import { Info } from "../../common/Info";

export default function AgencyCustomerReport() {
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customerReport, setcustomerReport] = useState([]);
  const [totalrecords, settotalrecords] = useState(0);
  const [currentpage, setCurrentPage] = useState(0);
  const [createdDate, setcreatedDate] = useState("");
  const [userName, setuserName] = useState("");
  const rowperpage=10

  const [SelectState, setSelectState] = useState([]);
  const [filterState, setfilterState] = useState("");
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const [data, setdata] = useState([]);
  const toggle = () => {
    setdropdownOpen(!dropdownOpen);
  };
  const headers = [
    { label: "Name", key: "userName" },
    { label: "Email", key: "email" },
    { label: "Address", key: "address" },
    { label: "Created Date", key: "createdDate" },
    // { label: "Dog Count", key: "dogCount" },
    { label: "Licese Count", key: "licenseCount" },
  ];

  const getCustomerReport = async (
    userName,
    createdDate,
    filterState,
    currentpage
  ) => {
    setLoading(true);
    const config = {
      method: "GET",
      url: AGENCY_CUSTOMER_REPORT,
      headers: authHeader(),
      params: {
        agencyId: getAgencyId(),
        count: rowperpage,
        offset: currentpage,
        email: userName,
        createdDate: createdDate,
        stateId: filterState,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setcustomerReport(data);
        const value = data.map((data) => ({
          userName: data.userName,
          email: data.email ? data.email : "N/A",
          address: data.address ? data.address : "N/A",
          createdDate: moment(data.createdDate).format("MM/DD/YY"),
          dogCount: data.dogCount,
          licenseCount: data.licenseCount,
        }));
        setdata(value);
        settotalrecords(totalCount);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const GetState = async () => {
    setLoading(true);
    const config = {
      method: "Get",
      url: STATE_LIST,
      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setSelectState(data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };

  const UserHandle = (e) => {
    setCurrentPage(0);
    setuserName(e.target.value);
  };

  const datefilterHandle = (e) => {
    setCurrentPage(0);
    setcreatedDate(moment(e.target.value).format("MM/DD/YY"));
  };

  const StateHandle = (e) => {
    setCurrentPage(0);
    setfilterState(e.target.value);
  };

  const Clear = () => {
    setuserName("");
    setcreatedDate("");
    setfilterState("");
  };
  const Export = () => {
    generatePDF(customerReport);
  };

  const AgencySearch = useRef(
    debounce((userName, createdDate, filterState, currentpage) =>
      getCustomerReport(userName, createdDate, filterState, currentpage)
    )
  ).current;

  useEffect(() => {
    GetState();
  }, []);

  useEffect(() => {
    AgencySearch(userName, createdDate, filterState, currentpage);
  }, [userName, createdDate, filterState, currentpage]);

  // useEffect(() => {
  //   getCustomerReport();
  // }, [currentpage]);

  return (
    <div className="agency-wrapper">
      {loading && <CustomPageLoading />}

      <Container fluid>
        <div className="page-title">
          <h4>
            Customer Report
            <Tooltip
              isOpen={id === "customerreport" && tooltipOpen}
              target={"customerreport"}
              toggle={() => tooltiptoggle("customerreport")}
            >
              Report of active customers
            </Tooltip>
            <span id={"customerreport"}>
              <Info />
            </span>
          </h4>

          <div className="top-btn">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle color="danger" caret>
                Export
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={Export}>PDF</DropdownItem>
                <DropdownItem>
                  <CSVLink
                    filename={"Customer_Report.csv"}
                    data={data}
                    headers={headers}
                  >
                    CSV
                  </CSVLink>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Button id="toggler" color="link">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14.371"
                height="14.371"
                viewBox="0 0 14.371 14.371"
              >
                <path
                  id="Icon_awesome-filter"
                  data-name="Icon awesome-filter"
                  d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                  fill="#1b3e6f"
                />
              </svg>
            </Button>
          </div>
        </div>

        <div className="mt-4">
          <UncontrolledCollapse toggler="#toggler">
            <Card body>
              <Row className="mt-3">
                <Col md="3">
                  <FormGroup>
                    <span>Search Email</span>

                    <Input
                      value={userName}
                      placeholder="Enter Email"
                      onChange={UserHandle}
                      type="text"
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <span>Search Created Date</span>

                    <Input
                      type="date"
                      placeholder="MM/DD/YYYY"
                      value={moment(createdDate).format("YYYY-MM-DD")}
                      onChange={datefilterHandle}
                      name=""
                      id=""
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <span>Select State</span>
                    <Input
                      type="select"
                      name="stateId"
                      value={filterState}
                      onChange={StateHandle}
                      id=""
                    >
                      <option value="">Select State</option>
                      {SelectState.map((i) => (
                        <option key={i.stateId} value={i.stateId}>
                          {i.stateName}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>

                <Col md="3">
                  <Button color="danger" onClick={Clear} className="mt-4">
                    Clear
                  </Button>
                </Col>
              </Row>
            </Card>
          </UncontrolledCollapse>
        </div>

        <Card body className="mt-4">
          <Table hover responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Address</th>
                <th>State</th>
                <th>Created Date</th>
                {/* <th>Dog Count</th> */}
                <th>License Count</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                ""
              ) : (
                <>
                  {customerReport.length === 0 ? (
                    <tr>
                      <td colSpan={9}>
                        <center>No Record Found</center>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {customerReport.map((report, index) => (
                        <tr>
                          <td>
                            {" "}
                            <div className="user-box">
                              <img
                              alt=""
                                src={
                                  report.profileImage
                                    ? report.profileImage
                                    : ProfileAvatar
                                }
                              />
                              {` `}
                              {report.userName ? report.userName : "N/A"}
                            </div>
                          </td>
                          <td>{report.email ? report.email : "N/A"}</td>
                          <td>{report.address ? report.address : "N/A"}</td>
                          <td>{report.stateName ? report.stateName : "N/A"}</td>
                          <td>
                            {report.createdDate ? report.createdDate : "N/A"}
                          </td>
                          {/* <td>{report.dogCount ? report.dogCount : "N/A"}</td> */}
                          <td>
                            {report.licenseCount ? report.licenseCount : "N/A"}
                          </td>
                        </tr>
                      ))}
                    </>
                  )}{" "}
                </>
              )}
            </tbody>
          </Table>
          <div className="d-flex flex-row py-4 justify-content-end">
            <Pagination
              itemClass="page-item"
              linkClass="page-link"
              activePage={currentpage + 1}
              itemsCountPerPage={rowperpage}
              totalItemsCount={totalrecords}
              onChange={onPageChange}
            />
          </div>
        </Card>
      </Container>
    </div>
  );
}
